import Vue from 'vue'
import Vuex from 'vuex'
import { ossBaseUrl } from '@/api/config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    imgHeadUrl: ossBaseUrl + '/',
    nodataUrl: ossBaseUrl + '/lyhccimgs/nodata.png',
    TXYSdkAppID: [1400495465, 1400514045, 1400494878], // 开发：1400495465 预发：1400514045 生产：1400494878
    TXIMisready: false
  },
  mutations: {
    SET_TX_IM_READY(state, d) {
      state.TXIMisready = d
    }
  },
  actions: {}
})
